import * as yup from "yup";
import { buildRecordTargetSchema } from "features/Resources/Shared/Components/Form/RecordTargetForm/schema";
import { pathSchema } from "features/Path/schema";
import { trigger } from "features/Trigger/TemplateTrigger/Form/schema";
import { reminderTriggerSchema } from "features/Trigger/ReminderTrigger/Form/schema";
import { TaskAction } from "../Task/models";

export const reminderSchema = yup.object({
  remindAtTrigger: reminderTriggerSchema,
});

export type ReminderSchema = yup.InferType<typeof reminderSchema>;

export const taskTemplateSchema = yup.object({
  pathIds: yup.array().of(yup.string().required()).optional().default([]),
  paths: yup.array().of(pathSchema).optional().default([]),
  name: yup.string().required().label("Title").max(70, "Title cannot be more than 70 characters"),
  description: yup.string().required().label("Description"),
  assignee: buildRecordTargetSchema("Assignee", true),
  startAtTrigger: trigger.required().label("Start At"),
  dueAtTrigger: trigger.required().label("Due"),
  taskAction: yup.mixed<TaskAction>().optional().label("Task Action"),
  messageBody: yup
    .string()
    .when("taskAction", {
      is: "send_message",
      then: (innerSchema) => innerSchema.required("Message body is required for message prompts"),
      otherwise: (innerSchema) => innerSchema.nullable(),
    }),

  messageRecipient: yup.mixed().label("Message Recipient").when("taskAction", {
    is: "send_message",
    then: () => buildRecordTargetSchema("Message Recipient", true),
    otherwise: () => yup.mixed().nullable(),
  }),
  customFormId: yup
    .number()
    .nullable()
    .label("Form")
    .when("taskAction", {
      is: "complete_form",
      then: (innerSchema) => innerSchema.required("A form is required for complete-form tasks"),
      otherwise: (innerSchema) => innerSchema.nullable(),
    }),
  reminders: yup.array().of(reminderSchema).optional().label("Reminders"),
  allowWeekends: yup.boolean().optional().default(false).label("Allow Weekends"),
});

export type TaskTemplateSchema = yup.InferType<typeof taskTemplateSchema>;

/**
 * NOTE: This schema type may include form-specific fields (like 'paths') that aren't sent to the API.
 * Use toCreateTaskTemplatePayload() or toUpdateTaskTemplatePayload() from ./helpers
 * to transform form data into the correct API payload structure.
 */
